import { useFormat } from 'vivat';

export default {
  types: {
    // _primaryControls: {
    //   width: '3rem',
    // },
    _increment: {
      name: 'ลำดับ',
      width: '3rem',
      class: {
        text: 'text-center',
        cell: 'text-center',
      },
    },
    // eslint-disable-next-line
    created_at: {
      name: 'วันที่ทำรายการ',
      width: '12rem',
      filter(val: any) {
        return useFormat.date(val).displayShortThaiDateTime();
      },
    },
    action: {
      name: 'การดำเนินการ',
      width: '1fr',
    },
    // eslint-disable-next-line
    logable_type: {
      name: 'โมดูล',
      width: '12rem',
      filter: (val: any, row: any) => row.item.logable?.__typename,
      class: {
        text: 'text-left',
        cell: 'text-center',
      },
    },
    // eslint-disable-next-line
    user_id: {
      name: 'ผู้ทำรายการ',
      width: '12rem',
      class: {
        text: 'text-left',
        cell: 'text-center',
      },
      filter: (val: any, row: any) => row.item.user.name || '',
    },
  },
  sortable: [
    'created_at',
    'action',
    'logable_type',
    // 'module',
    'user_id',
  ],
};
